export const sortedData = (array) =>
  array.sort(function (a, b) {
    return new Date(b.when) - new Date(a.when);
  });
